var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.17,
    height: 20.3,
    viewBox: "0 0 21.17 20.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "devices",
    d: "M10.435,14.913v3.478a.872.872,0,0,1-.87.87H6.087a.87.87,0,1,1,0-1.739H8.7V15.783H4.348A4.349,4.349,0,0,1,0,11.435V5.348A4.349,4.349,0,0,1,4.348,1H14.783A4.349,4.349,0,0,1,19.13,5.348a.87.87,0,0,1-1.739,0,2.616,2.616,0,0,0-2.609-2.609H4.348A2.616,2.616,0,0,0,1.739,5.348v6.087a2.616,2.616,0,0,0,2.609,2.609H9.565A.872.872,0,0,1,10.435,14.913ZM20.87,11.435v6.087A3.477,3.477,0,0,1,17.391,21H15.652a3.477,3.477,0,0,1-3.478-3.478V11.435a3.477,3.477,0,0,1,3.478-3.478h1.739A3.477,3.477,0,0,1,20.87,11.435Zm-1.739,0A1.744,1.744,0,0,0,17.391,9.7H15.652a1.744,1.744,0,0,0-1.739,1.739v6.087a1.744,1.744,0,0,0,1.739,1.739h1.739a1.744,1.744,0,0,0,1.739-1.739Z",
    transform: "translate(0.15 -0.85)",
    stroke: "#fff",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDevices);
export default __webpack_public_path__ + "static/media/active_devices.8d6364045126fd63e8f6239e3d007706.svg";
export { ForwardRef as ReactComponent };